import React, { Component } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import TableFilters from '../Custom/TableFilters';
import CustomTooltip from '../layout/Tooltip';

function onFilterApply(name, filterId) {
  let obj = [];
  obj = Array.from(
    document.querySelectorAll(`input[name=${name}]:checked`)
  ).map((checkbox) => checkbox.value.toLowerCase());
  return obj.length > 0
    ? obj.includes(filterId.toString().toLowerCase())
    : true;
}

class Table extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data,
      filterdData: this.props.FilteredFaultData,
      highlightedValue: this.props.selectedValue,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data,
      filterdData: nextProps.FilteredFaultData,
      highlightedValue: nextProps.selectedValue,
    });

    // to heilight row of table
    try {
      if (nextProps.selectedValue !== '') {
        // document.getElementById("fltrCriticalityIndex0").checked = true;
        // Chkinput.onChange('C1');
        document.getElementById(nextProps.selectedValue).scrollIntoView({
          block: 'center',
          behavior: 'smooth',
          inline: 'start',
        });
      }
    } catch (err) {
      console.log(err);
    }
  }

  render() {
    const { data, filterdData, highlightedValue } = this.state;
    const {
      fltrdFeeder,
      fltrdCable,
      fltrdSection,
      fltrdCI,
      fltrdHI,
      fltrdLength,
      fltrdAge,
      fltrdPOF,
    } = this.props.filters;

    const fltrdFeederCount = [
      ...new Set(filterdData.map((item) => item.AssetName)),
    ].length;
    const fltrdCableCount = [
      ...new Set(filterdData.map((item) => item.CableAssetName)),
    ].length;
    const fltrdSectionCount = [
      ...new Set(filterdData.map((item) => item.CableObjectId)),
    ].length;
    const fltrdPOFCount = [...new Set(filterdData.map((item) => item.POF))]
      .length;
    const pageSize = filterdData.length;
    // var cofCount = 0;
    // for (var i in filterdData) {
    //     cofCount += parseInt(filterdData[i].COF);
    // }

    let lengthCount = 0;
    for (var j in filterdData) {
      lengthCount += parseFloat(filterdData[j].SectionLengthKM);
    }

    const currentState = this;

    return (
      <ReactTable
        data={data}
        showPagination={false}
        className="-striped -highlight"
        style={{
          height: 'calc(100vh - 165px)',
        }}
        pageSize={pageSize < 10 ? 10 : pageSize}
        resizable={false}
        sortable={true}
        filterable
        getTrProps={(state, rowInfo) => ({
          onClick: () => {
            // pass data to heat map.
            const selectedRowIdValue = rowInfo.row._original.id;
            this.props.passDataToHeatMap(selectedRowIdValue);
          },
          className:
            rowInfo !== undefined
              ? rowInfo.row._original.id === highlightedValue
                ? 'rowActive'
                : ''
              : '',
        })}
        onFilteredChange={function (filtered, rowInfo, row, filteredData) {
          const finalFilteredData = filteredData.map((x) => x._original);
          currentState.props.onFilteredDataChanges(finalFilteredData);
        }}
        columns={[
          {
            Header: () => (
              <div>
                <div className="bold-black">Feeder</div>
                <div className="bold-gray">{fltrdFeederCount}</div>
              </div>
            ),
            accessor: 'AssetName',
            minWidth: 90,
            className: 'text-center',
            filterable: true,
            Cell: (row) => {
              row.styles.backgroundColor = row.original.Colcolor;
              return (
                <CustomTooltip
                  tooltip={`Customer count ${row.original.ConsumerPerFeeder}`}
                  id={`tltpFeeder${row.index}`}
                  placement={'bottom'}
                >
                  {row.value}
                </CustomTooltip>
              );
            },
            filterMethod: (filter, row) =>
              onFilterApply('AssetName', row[filter.id]),
            Filter: ({ onChange }) => (
              <TableFilters
                position="-36px"
                onChange={onChange}
                filterObj={fltrdFeeder}
                valueObj={fltrdFeeder}
                name="AssetName"
                id="fltrFeeder"
                listid="lstfltrFeeder"
              />
            ),
          },
          {
            Header: () => (
              <div>
                <div className="bold-black">Cable</div>
                <div className="bold-gray">{fltrdCableCount}</div>
              </div>
            ),
            accessor: 'CableAssetName',
            minWidth: 120,
            className: 'text-center',
            filterable: true,
            Cell: (row) => (
              <CustomTooltip
                tooltip={`Customer count ${row.original.ConsumersPerCable}`}
                id={`tltpCable${row.index}`}
                placement={'bottom'}
              >
                {row.value}
              </CustomTooltip>
            ),
            filterMethod: (filter, row) =>
              onFilterApply('CableAssetName', row[filter.id]),
            Filter: ({ onChange }) => (
              <TableFilters
                position="-36px"
                onChange={onChange}
                filterObj={fltrdCable}
                valueObj={fltrdCable}
                name="CableAssetName"
                id="fltrCableAssetName"
                listid="lstfltrCableAssetName"
              />
            ),
          },
          {
            Header: () => (
              <div>
                <div className="bold-black">Section</div>
                <div className="bold-gray">{fltrdSectionCount}</div>
              </div>
            ),
            accessor: 'CableObjectId',
            minWidth: 120,
            className: 'text-center',
            filterable: true,
            Cell: (row) => (
              <CustomTooltip
                tooltip={`Customer count ${row.original.ConsumersPerCS}`}
                id={`tltpSection${row.index}`}
                placement={'bottom'}
              >
                {row.value}
              </CustomTooltip>
            ),
            filterMethod: (filter, row) =>
              onFilterApply('CableObjectId', row[filter.id]),
            Filter: ({ onChange }) => (
              <TableFilters
                position="-36px"
                onChange={onChange}
                filterObj={fltrdSection}
                valueObj={fltrdSection}
                name="CableObjectId"
                id="fltrCableObjectId"
                listid="lstfltrCableObjectId"
              />
            ),
          },
          {
            Header: () => <div className="bold-black">CI</div>,
            accessor: 'CriticalityIndex',
            id: 'CriticalityIndex',
            minWidth: 50,
            className: 'text-center',
            filterable: true,
            Cell: (row) => {
              row.styles.backgroundColor = row.original.CIColor;
              return (
                <CustomTooltip
                  tooltip={`Tot cost:${row.original.COF}Kr. Env cost:${row.original.CoFEnvironment}Kr. Fin cost:${row.original.CoFFinancial}Kr.`}
                  id={`tltpCI${row.index}`}
                  placement={'bottom'}
                >
                  {row.value}
                </CustomTooltip>
              );
            },
            filterMethod: (filter, row) => {
              console.log('clicled');
              return onFilterApply('CriticalityIndex', row[filter.id]);
            },
            Filter: ({ onChange }) => (
              <TableFilters
                position="-36px"
                onChange={onChange}
                filterObj={fltrdCI}
                valueObj={fltrdCI}
                name="CriticalityIndex"
                id="fltrCriticalityIndex"
                listid="lstfltrCriticalityIndex"
              />
            ),
          },
          {
            Header: () => <div className="bold-black">HI</div>,
            accessor: 'HealthIndexBand',
            minWidth: 50,
            className: 'text-center',
            filterable: true,
            Cell: (row) => {
              row.styles.backgroundColor = row.original.HIColor;
              return row.value;
            },
            filterMethod: (filter, row) =>
              onFilterApply('HealthIndexBand', row[filter.id]),
            Filter: ({ onChange }) => (
              <TableFilters
                position="-36px"
                onChange={onChange}
                filterObj={fltrdHI}
                valueObj={fltrdHI}
                name="HealthIndexBand"
                id="fltrHealthIndexBand"
                listid="lstfltrHealthIndexBand"
              />
            ),
          },
          {
            Header: () => <div className="bold-black">Age</div>,
            accessor: 'AgeOfCable',
            minWidth: 50,
            className: 'text-center',
            filterable: true,
            Cell: (row) => {
              row.styles.color =
                row.original.AgeDisplayColor === '#6E6E6E' ||
                row.original.AgeDisplayColor === '#8F8F8F' ||
                row.original.AgeDisplayColor === '#4A4A4A'
                  ? '#fff'
                  : '#000';
              row.styles.backgroundColor = row.original.AgeDisplayColor;
              return (
                <CustomTooltip
                  tooltip={`Remaining life ${row.original.RemainingLife}`}
                  id={`tltpAge${row.index}`}
                  placement={'bottom'}
                >
                  {row.value}
                </CustomTooltip>
              );
            },
            filterMethod: (filter, row) =>
              onFilterApply('AgeOfCable', row[filter.id]),
            Filter: ({ onChange }) => (
              <TableFilters
                position="-36px"
                onChange={onChange}
                filterObj={fltrdAge}
                valueObj={fltrdAge}
                name="AgeOfCable"
                id="fltrAgeOfCable"
                listid="lstfltrAgeOfCable"
              />
            ),
          },
          {
            Header: () => (
              <div>
                <div className="bold-black">Length (km)</div>
                <div className="bold-gray">{lengthCount.toFixed(2)}</div>
              </div>
            ),
            accessor: 'SectionLengthKM',
            minWidth: 80,
            className: 'text-center',
            filterable: true,
            filterMethod: (filter, row) =>
              onFilterApply('SectionLengthKM', row[filter.id]),
            Filter: ({ onChange }) => (
              <TableFilters
                position="-36px"
                onChange={onChange}
                filterObj={fltrdLength}
                valueObj={fltrdLength}
                name="SectionLengthKM"
                id="fltrSectionLength"
                listid="lstfltrSectionLength"
              />
            ),
          },
          {
            Header: () => (
              <div>
                <div className="bold-black">PoF (%)</div>
                <div className="bold-gray">{fltrdPOFCount}</div>
              </div>
            ),
            accessor: 'POF',
            minWidth: 70,
            className: 'text-center',
            filterable: true,
            filterMethod: (filter, row) => onFilterApply('POF', row[filter.id]),
            Filter: ({ onChange }) => (
              <TableFilters
                position="-36px"
                onChange={onChange}
                filterObj={fltrdPOF}
                valueObj={fltrdPOF}
                name="POF"
                id="fltrPOF"
                listid="lstfltrPOF"
              />
            ),
          },
        ]}
      />
    );
  }
}

export default Table;
